import React from "react";

class Loading extends React.Component {
	render() {
		if (!this.props.loading) return null;
		return (
			<li className="ticker">
				<a>Loading...</a>
			</li>
		);
	}
}

class Error extends React.Component {
	render() {
		if (!this.props.isError) return null;
		return (
			<li className="ticker">
				<a>Error Occured, please try again...</a>
			</li>
		);
	}
}

class EachResult extends React.Component {
	render() {
		return (
			<li className="ticker" key={exchange.name + security.index}>
				<a href="#" onClick={self.onSelect.bind(self, exchange.name, security.type, security.id, security.name, security.code)}>
					<div className="clearfix">
						<div className="info">
							{security.name}
							<br />
							{security.code}
							<br />
						</div>
					</div>
				</a>
			</li>
		);
	}
}

class PageNavigation extends React.Component {
	showPrevPage() {

	}
	showNextPage() {

	}
	render() {
		let result = this.props.results.prevStartIndex || null;
		if (result === null) return null;
		return (
			<li className="pull-right" key="page" >
				<nav>
					<ul className="pagination">
						<li className={this.props.results.prevStartIndex === null ? "disabled" : ""}>
							<a href="#" onClick={this.showPrevPage}><span>Prev</span></a>
						</li>
						<li className={this.props.results.nextStartIndex === null ? "disabled" : ""}>
							<a href="#" onClick={this.showNextPage}><span>Next</span></a>
						</li>
					</ul>
				</nav>
			</li>
		);
	}
}

class ExchangeHead extends React.Component {
	render() {
		var { exchange } = this.props;
		return (
			<li className="dropdown-header">{exchange}</li>
		);
	}
}

class ExchangeResult extends React.Component {
	render() {
		let { security, exchange, onClick } = this.props;
		return (
			<li className="ticker">
				<a href="#" onClick={onClick.bind(this, exchange, security)}>
					<div className="clearfix">
						<div className="info">
							{`${ security.name } (${ security.code })`}
						</div>
					</div>
				</a>
			</li>
		);
	}
}

export default class SecuritySearchResult extends React.Component {
	render() {
		let { showDropDown, showLoading, results, error, onSelect } = this.props;
		if (!showDropDown) return null;

		let items = [];
		if (results.exchange) {
			items = results.exchange.map((exchange, idx) => {
				let securityElement = exchange.securities
					.map((security, idx2) => <ExchangeResult key={`${idx}-${idx2}`} exchange={exchange.name} security={security} onClick={onSelect}/>);
				return [<ExchangeHead key={idx} exchange={exchange.name} />].concat(securityElement);
			})
			.reduce((a1, a2) => a1.concat(a2));
		}
		return (
			<ul className="dropdown-menu autocomplete" role="menu">
				<Loading loading={showLoading} />
				<Error {...error} />
				{items}
				<PageNavigation results={results} />
			</ul>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/scripts/components/page/ChartPage/SecuritySearchResult.jsx
 **/